require('./preGrantedCreditStepTwo.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const ContractLoanDueInformation = require('../../contractLoanDueInformation/contractLoanDueInformation');

// @constants
const { MIN_VALUE_REQUEST_AMOUNT, MAX_VALUE_REQUEST_AMOUNT } = require('../../../../loansConstants/index').preGrantedCredit;
const { MIN_LABEL, MAX_LABEL, EURO_SYMBOL } = require('constants/index');
const { BLOCKED_ACCOUNTS_PREGRANTED_CREDIT } = require('constants/operationCodesAccounts');
const { PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL, EVIDENCE_OVERDRAFT } = require('constants/flagBasedFeatures');

//@utilities
const { toFirstUppercase } = require('utilities/stringHelper');
const { getFilteredAccountIndexes } = require('../../../../loansUtilities/loansHelper');
const { formatAmount } = require('utilities/currencyHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class PreGrantedCreditStepTwo extends React.Component {

    constructor(props) {
        super(props);

        this.handleAmountChange = this.handleAmountChange.bind(this);
    }

    componentDidMount() {
        const {
            getBlockedAccounts,
            immAccounts,
            immFlagBasedFeatures,
            sendLoansBarePrecontractualEmail
        } = this.props;

        if (!immAccounts.get('blockedAccountsSuccess')) {
            const accounts = getFilteredAccountIndexes(immAccounts).map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, BLOCKED_ACCOUNTS_PREGRANTED_CREDIT);
        }
        if (!__CONTACT_CENTER__ && immFlagBasedFeatures.get(PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL)) {
            sendLoansBarePrecontractualEmail();
        }
    }

    componentDidUpdate() {
        const { setInitApiFlag, immPreGrantedCredit, onAgreeReset, onAgreeCheckbox, immFlagBasedFeatures, officePrintReset, resetMailSent } = this.props;
        if (immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT) || !immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT)) {
            if ((immPreGrantedCredit.get('selectedAmount') !== immPreGrantedCredit.get('firstSelectedAmount')) || (immPreGrantedCredit.get('selectedAccount') !== immPreGrantedCredit.get('firstSelectedAccount'))) {  
                setInitApiFlag(true, true, false, false);
                __CONTACT_CENTER__ && !isPrintOfficeMode() && resetMailSent(false);
                if (immPreGrantedCredit.get('agree') || immPreGrantedCredit.get('confirmationCheckbox')) {
                    onAgreeReset();
                }
                if (isPrintOfficeMode() && immPreGrantedCredit.get('officePrintStepThree')) {
                    officePrintReset();
                }
            } else {
                setInitApiFlag(false, false, true, false);
                if (!immPreGrantedCredit.get('agree') || immPreGrantedCredit.get('confirmationCheckbox')) {
                    onAgreeCheckbox();
                }
                if (isPrintOfficeMode() && !immPreGrantedCredit.get('officePrintStepThree')) {
                    officePrintReset(true);
                }
                __CONTACT_CENTER__ && !isPrintOfficeMode() && resetMailSent(true);
            }
        }
    }

    handleAmountChange(selectedAmount) {
        if (selectedAmount) {
            this.props.setLoanAmount({ selectedAmount });
        }
    }

    setSingleAccount(accountsIndexes) {
        const singleAccount = accountsIndexes.get(0);
        this.handleFromAccountChange(singleAccount);
    }

    buildDropDownAccounts() {
        const { immAccounts, immPreGrantedCredit, setSelectedAccount } = this.props;
        const accountIndexes = getFilteredAccountIndexes(immAccounts);
        const errorMessage = formatText('contractsView-dropdownAccountsError');
        let enabled = !(Array.isArray(accountIndexes) && accountIndexes.length === 1);
        const disclaimer = {
            warning: 'preGrantedCredit-preGrantedCredit_blockedAccountsWarning',
            important: 'preGrantedCredit-preGrantedCredit_blockedAccountsImportant'
        };

        return !immAccounts.get('blockedAccountsLoading') ? (
            <DropdownAccounts
                blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                disclaimer={disclaimer}
                id="drd_ContractView"
                immAccounts={immAccounts.get('byId')}
                accountsIndexes={accountIndexes.toJS()}
                onAccountChange={setSelectedAccount}
                currentAccountId={immPreGrantedCredit.get('selectedAccount')}
                error={immPreGrantedCredit.get('errorSelectedAccount')}
                errorMsg={errorMessage}
                enabled={enabled}
                showAvailableBalance
                label="contractsView-preGrantedCreditDropdwonLabel"
                tooltipMsg="inactiveAccounts-inactiveAccounts_dropdownCommonToolTip"
                showInactiveAccountsAsBlocked
            />
        ) : <LoadingSection />;
    }

    buildSectionHeader() {
        return (
            <h4 className="pre-granted-credit-step-two__section-header">
                <FormattedText value="contractsView-amount" />
            </h4>
        );
    }

    buildTooltip() {
        const content = (
            <article>
                <div className="pre-granted-credit-step-two__tooltip"><FormattedText value="contractsView-preGrantedCreditTooltipTitle" /></div>
                <div className="pre-granted-credit-step-two__tooltip"><FormattedText value="contractsView-preGrantedCreditTooltip1" /></div>
                <div className="pre-granted-credit-step-two__tooltip"><FormattedText value="contractsView-preGrantedCreditTooltip2" /></div>
            </article>
        );
        return (
            <OKTooltip
                content={content}
                modifier="dark-bg"
                offset={[0, -15]}
                type="custom"
            />
        );
    }

    buildSlider() {
        const { immPreGrantedCredit } = this.props;

        const sliderLabel = formatText("contractsView-preGrantedCreditSliderLabel");
        const maxValue = formatAmount(MAX_VALUE_REQUEST_AMOUNT, getLanguage(), 0);
        const minLabel = `${toFirstUppercase(MIN_LABEL)} ${MIN_VALUE_REQUEST_AMOUNT}`;
        const maxLabel = `${toFirstUppercase(MAX_LABEL)} ${maxValue}`;

        return (
            <article className="contract-slider">
                <section className="contract-slider__slider-container">
                    <OKSliderInput
                        defaultValue={immPreGrantedCredit.get('selectedAmount')}
                        extraInfo={this.buildTooltip()}
                        inputType="formatWithDecimal"
                        max={MAX_VALUE_REQUEST_AMOUNT}
                        maxLabel={maxLabel}
                        min={MIN_VALUE_REQUEST_AMOUNT}
                        minLabel={minLabel}
                        onChange={this.handleAmountChange}
                        title={sliderLabel}
                        unit={EURO_SYMBOL}
                    />
                </section>
            </article>
        );
    }

    buildPersonalDisclaimer() {
        return (
            <ContractLoanDueInformation title="gdprPreGrantedCredit-title" message="gdprPreGrantedCredit-message" />
        );
    }


    render() {
        const dropdownAccounts = this.buildDropDownAccounts();
        const sectionHeaderAmount = this.buildSectionHeader();
        const slider = this.buildSlider();
        const personalDisclaimer = this.buildPersonalDisclaimer();

        return (
            <div className="pre-granted-credit-step-two">
                <FormattedText value="contractsView-preGrantedCreditStep2Title"
                    className="pre-granted-credit-step-two__title" />
                {dropdownAccounts}
                {sectionHeaderAmount}
                {slider}
                {personalDisclaimer}
            </div>
        );
    }
}

PreGrantedCreditStepTwo.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired,
    sendLoansBarePrecontractualEmail: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setInitApiFlag: PropTypes.func.isRequired,
    onAgreeReset: PropTypes.func,
    onAgreeCheckbox: PropTypes.func,
    officePrintReset: PropTypes.func,
    resetMailSent : PropTypes.func
};

module.exports = PreGrantedCreditStepTwo;
